const moduloPromociones = {
  agGrid: {
    paginacion: 15,
    id: 'myGridListGaritas',
    class: 'ag-theme-alpine',
    style: {
      width: '100%',
      height: '600px'
    }
  },
  titulos: {
    promociones: {
      titulo: 'Promoción',
      modulo: 'Promociones',
      tituloCardListar: 'Listado de Promociones',
    },
    

  },
  button: {
    buttonsCss: {
      danger: 'btn btn-danger btn-block',
      info: 'btn btn-info btn-block'
    },
    buttonsNombre: {
      //*GLOBAL
      editar: 'Editar',
      eliminar: 'Eliminar',
      nuevo: 'Nuevo',
      nueva: 'Nueva',
      ejecutar: 'Ejecutar',
      agregar: 'Agregar',
      imprimir: 'Imprimir',
    }
  },
  mensajes: {
    eliminar: '¿Esta seguro que desea eliminar el siguiente registro?',
    actualizar: '¿Esta seguro que desea actualizar el siguiente registro?',
    datoGuardado: 'Se guardo corectamente..!!',
    completeInformacion: 'Complete la informacion requerida',
    mensajeAdvertencia: 'La Órden contiene un solo elemento en el detalle desea eliminar la órden completa?',
    guardarDatorForm: 'Desea guardar los datos del formulario',
    mjsProcesar: 'Desea procesar los datos del formulario',
    mjsCampo: 'Al menos debe contener otro Campo "Articulo Alternativo"',
    mjsCampo1: 'Al menos debe contener otro Campo "CodigoBarra"',
    mjsCampo2: 'Al menos debe contener otro Campo',
    mjsCampoAdv: 'Obligatorio Campo Cantidad',
    mjsFilasCorrectas: 'Filas Correctas',
    mjsFilasIncorrectas: 'Filas Incorrectas',
    procesar: '¿Esta seguro que desea procesar el siguiente formulario?'
  },
  url: {
    promociones: {
      crear: '/promocion',
      eliminar: '/promocion/',
      obtenerTodo: '/promocion',
      tipos: '/catalogo/tipo-promocion',
    },
    bonificador: {
      crear: '/bonificador',
      borrar: '/bonificador',
      obtener: '/bonificador',
      obtenerPorIdPromo: '/bonificador?idPromo=',
    },
    bonificadorRegalo: {
      crear: '/regalo',
      borrar: '/regalo',
      obtener: '/regalo',
      obtenerPorIdPromo: '/regalo?idPromo=',
    },
    grupo: {
      crear: '/grupos',
      borrar: '/grupos',
      obtener: '/grupos',
      obtenerPorIdPromo: '/grupos?idPromo=',
      validar: '/grupos/findById',
    },
    condSubmarca: {
      crear: '/promo-sub-marca',
      borrar: '/promo-sub-marca',
      obtener: '/promo-sub-marca',
      obtenerPorIdPromo: '/promo-sub-marca?idPromo=',
    },
    condGrupoCliente: {
      crear: '/cond-grupo-cliente',
      borrar: '/cond-grupo-cliente',
      obtener: '/cond-grupo-cliente',
      obtenerPorIdPromo: '/cond-grupo-cliente?idPromo=',
    },
    condCliente: {
      crear: '/cond-cliente',
      borrar: '/cond-cliente',
      obtener: '/cond-cliente',
      obtenerPorIdPromo: '/cond-cliente?idPromo=',
    },
    condOficinaVenta: {
      crear: '/cond-oficina-venta',
      borrar: '/cond-oficina-venta',
      obtener: '/cond-oficina-venta',
      obtenerPorIdPromo: '/cond-oficina-venta?idPromo=',
    },
    condVendedor: {
      crear: '/cond-vendedor',
      borrar: '/cond-vendedor',
      obtener: '/cond-vendedor',
      obtenerPorIdPromo: '/cond-vendedor?idPromo=',
    },
    
    condicionTier: {
      crear: '/cond-tiers',
      delete: '/cond-tiers?idTiers=', // concat el services idPromo
      getAll: '/cond-tiers?idPromo='
    },

    proveedor: {
      obtenerPorRuc: 'proveedor/ruc/',
      obtenerPorId: 'proveedor/'
    },
    material: {
      obtenerPorId: 'material/'
    },
    cliente: {
      obtenerPorId: 'cliente/'
    },
    unidad: {
      unidad: 'material-presentacion/pk?pkMaterial='
    },
    grupoCliente: {
      obtenerPorId: 'grupo-cliente/',
      ontenerTodos: 'grupo-cliente',
    },
    oficinaVenta: {
      validar: '/oficina-venta/',
      ontenerTodos: '/oficina-venta',
    },
    vendedor: {
      validar: '/vendedor/id/',
    },
    submarca: {
      validar: '/submarca/',
    },
    
    //T.20331 Essential: nuevas cond. para promos
    //PROMO SUBCANAL
    condAgrupacionTarifa: {
      crear   : '/cond-subcanal',
      delete  : '/cond-subcanal',
      getAll  : '/cond-subcanal?idPromo=',// concat el services idPromo
      getById : '/cond-subcanal', 
    },
    //PROMO CANAL CLIENTE
    condCanalVendedor: {
      crear   : '/cond-canal-cliente',
      delete  : '/cond-canal-cliente',
      getAll  : '/cond-canal-cliente?idPromo=',// concat el services idPromo
      getById : '/cond-canal-cliente',
    },
    // T.20331
    // COND_VARIANTE (Combos)
    condVariante: {
      crear: '/cond-variante',
      borrar: '/cond-variante',
      obtener: '/cond-variante',
      obtenerPorIdPromo: '/cond-variante?idPromo=',
      obtenerPorMaterial: '/cond-variante/byMaterial',
      obtenerPorId: '/cond-variante/findById',
      borrarPorPromo: '/cond-variante/',
    },

  }
}

export {moduloPromociones}
